<div fxLayout="column" fxLayoutGap="8px" class="w-100">
    @for (doc of documents; track doc.id; let i = $index) {
        <div class="bc-primary-gray-50 radius-8 pl-8 pr-8 pt-16 pb-16 pointer"
             fxLayout="row" fxLayoutAlign="space-between center"
             (click)="openDocument(doc)">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                <span class="t2-semi-bold c-primary-gray-900">{{ i + 1 }}. {{ doc.name }}</span>
                <ui-kit-svg class="i-16" name="ic_new_tab"/>
            </div>
            <span class="t4 c-primary-gray-600">
                {{ 'i18n_af_faqUpdated' | translate }}: {{ (doc.updatedDate ?? doc.createdDate) | date:'dd.MM.yy HH:mm:ss' }}
            </span>
        </div>
    }
</div>
